import { render, staticRenderFns } from "./TrendyCollection.vue?vue&type=template&id=2500ab5e&"
import script from "./TrendyCollection.vue?vue&type=script&lang=js&"
export * from "./TrendyCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2500ab5e')) {
      api.createRecord('2500ab5e', component.options)
    } else {
      api.reload('2500ab5e', component.options)
    }
    module.hot.accept("./TrendyCollection.vue?vue&type=template&id=2500ab5e&", function () {
      api.rerender('2500ab5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/home/TrendyCollection.vue"
export default component.exports